<template>
  <head>
    <meta charset="utf-8"/>
    <title>Maji H2O | SBP Filter Map</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Premium Multipurpose Admin & Dashboard Template" name="description"/>
    <meta content="Themesbrand" name="author"/>
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>

    <!-- Bootstrap Rating css -->
    <link href="assets/libs/bootstrap-rating/bootstrap-rating.css" rel="stylesheet" type="text/css"/>

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>

    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">

    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>

    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>

    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>

    <!-- map Css-->
    <link href="assets/css/map.css" id="app-style" rel="stylesheet" type="text/css"/>
  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">
      <!-- Business details side bar -->
      <div class="modal fade trip-details-modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5>Business Details</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <!-- Modal content here -->
            </div>
          </div>
        </div>
      </div>

      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">SBP Filter Map</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item active">SBP Filter Map</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Filter Controls -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title mb-4">Filter Business Locations</h5>
                  <div class="row">
                    <!-- SubCounty Filter -->
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label class="form-label">Sub County</label>
                        <select class="form-select" id="subCountyFilter" v-model="selectedSubCounty" @change="onSubCountyChange">
                          <option value="">All Sub Counties</option>
                          <option v-for="subCounty in subCounties" :key="subCounty.subCountyID" :value="subCounty.subCountyID">
                            {{subCounty.subCountyName}}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Ward Filter -->
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label class="form-label">Ward</label>
                        <select class="form-select" id="wardFilter" v-model="selectedWard" @change="onWardChange" :disabled="!selectedSubCounty">
                          <option value="">All Wards</option>
                          <option v-for="ward in wards" :key="ward.wardID" :value="ward.wardID">
                            {{ward.wardName}}
                          </option>
                        </select>
                        <small class="text-muted" v-if="!selectedSubCounty">Select a Sub County first</small>
                      </div>
                    </div>

                    <!-- Zone Filter -->
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label class="form-label">Zone <span class="text-muted">(Optional)</span></label>
                        <select class="form-select" id="zoneFilter" v-model="selectedZone" :disabled="!selectedSubCounty && !selectedWard">
                          <option value="">All Zones</option>
                          <option v-for="zone in zones" :key="zone.id" :value="zone.id">
                            {{zone.zone}} - {{zone.zoneCategory}}
                          </option>
                        </select>
                        <small class="text-muted">Zone filter is optional and only available for areas with defined zones</small>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-md-12">
                      <button class="btn btn-primary me-2" @click="applyFilters">
                        <i class="bx bx-filter-alt me-1"></i> Apply Filters
                      </button>
                      <button class="btn btn-secondary me-2" @click="clearFilters">
                        <i class="bx bx-reset me-1"></i> Clear Filters
                      </button>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="checkbox" id="autoApplyFilters" v-model="autoApplyFilters">
                        <label class="form-check-label" for="autoApplyFilters">
                          Auto-apply filters on change
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="checkbox" id="zoomToMiddle" v-model="zoomToMiddle" checked>
                        <label class="form-check-label" for="zoomToMiddle">
                          Zoom to center business
                        </label>
                      </div>
                    </div>
                  </div>

                  <!-- Statistics Cards -->
                  <div class="row mt-4">
                    <div class="col-md-3">
                      <div class="card mini-stats-wid">
                        <div class="card-body">
                          <div class="d-flex">
                            <div class="flex-grow-1">
                              <p class="text-muted fw-medium">Total Businesses</p>
                              <h4 class="mb-0">{{totalBusinesses}}</h4>
                            </div>
                            <div class="flex-shrink-0 align-self-center">
                              <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                                                                <span class="avatar-title">
                                                                    <i class="bx bx-store font-size-24"></i>
                                                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <div class="card mini-stats-wid">
                        <div class="card-body">
                          <div class="d-flex">
                            <div class="flex-grow-1">
                              <p class="text-muted fw-medium">Compliant</p>
                              <h4 class="mb-0 text-success">{{compliantCount}}</h4>
                            </div>
                            <div class="flex-shrink-0 align-self-center">
                              <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                                                                <span class="avatar-title">
                                                                    <i class="bx bx-check-circle font-size-24"></i>
                                                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <div class="card mini-stats-wid">
                        <div class="card-body">
                          <div class="d-flex">
                            <div class="flex-grow-1">
                              <p class="text-muted fw-medium">Non-Compliant</p>
                              <h4 class="mb-0 text-danger">{{nonCompliantCount}}</h4>
                            </div>
                            <div class="flex-shrink-0 align-self-center">
                              <div class="mini-stat-icon avatar-sm rounded-circle bg-danger">
                                                                <span class="avatar-title">
                                                                    <i class="bx bx-x-circle font-size-24"></i>
                                                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <div class="card mini-stats-wid">
                        <div class="card-body">
                          <div class="d-flex">
                            <div class="flex-grow-1">
                              <p class="text-muted fw-medium">Compliance Rate</p>
                              <h4 class="mb-0">{{complianceRate}}%</h4>
                            </div>
                            <div class="flex-shrink-0 align-self-center">
                              <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                                                                <span class="avatar-title">
                                                                    <i class="bx bx-pie-chart-alt font-size-24"></i>
                                                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Map Container -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div id="filterMap" class="w-100 mt-1 h-100 live-map-cont main-map-container" style="height: 600px;"></div>
                </div>
              </div>

              <div class="">
                <div class="position-relative">
                  <!-- Map Container -->
                  <div class="">
                    <div class="position-relative">
                      <!-- Zoom Controls -->
                      <div class="position-absolute" style="top: 10px; right: 60px; z-index: 5;">
                        <div class="btn-group-vertical" role="group">
                          <button type="button" class="btn btn-sm btn-light" @click="zoomIn" title="Zoom In">
                            <i class="bx bx-plus"></i>
                          </button>
                          <button type="button" class="btn btn-sm btn-light" @click="zoomOut" title="Zoom Out">
                            <i class="bx bx-minus"></i>
                          </button>
                          <button type="button" class="btn btn-sm btn-light" @click="resetZoom" title="Reset Zoom">
                            <i class="bx bx-fullscreen"></i>
                          </button>
                        </div>
                      </div>

                      <!-- Map search input box -->
                      <div class="form-group map-searcher">
                        <input type="text" class="form-control form-control-lg text-black"
                               placeholder="Search for a location" id="pac-input-filter">
                        <button title="Clear search results"
                                class="btn btn-transparent border-0 clear-map">
                          <i class="mdi mdi-close d-none"></i>
                        </button>
                      </div>

                      <!-- Key button -->
                      <div class="map-key-card card">
                        <div class="card-body">
                          <i class="mdi mdi-key-variant"></i>
                        </div>
                      </div>

                      <!-- Key items -->
                      <div class="card map-card animated slideInLeft d-none">
                        <span class="close-map-key"><i class="zmdi zmdi-close"></i></span>
                        <div class="card-body">
                          <h4 class="card-title">Map Key</h4>
                        </div>
                        <div class="listview py-4 map-key">
                                            <span class="listview__item py-0">
                                                <img src="assets/images/map-assets/biz/compliant-biz-business.png"
                                                     class="listview__img" alt="">
                                                <div class="listview__content d-flex align-items-center">
                                                    <div class="listview__heading"><strong>Compliant Businesses</strong></div>
                                                </div>
                                            </span>

                          <span class="listview__item py-0">
                                                <img src="assets/images/map-assets/biz/noncomplant-business.png"
                                                     class="listview__img" alt="">
                                                <div class="listview__content d-flex align-items-center">
                                                    <div class="listview__heading"><strong>Non-Compliant Businesses</strong></div>
                                                </div>
                                            </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Loading Overlay -->
              <div v-if="loading" class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                   style="background-color: rgba(0,0,0,0.5); z-index: 9999;">
                <div class="text-center text-white">
                  <div class="spinner-border text-primary mb-3" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <h5>{{loadingMessage}}</h5>
                </div>
              </div>
            </div>
          </div>

          <!-- Business Details Offcanvas -->
          <div class="offcanvas offcanvas-start" tabindex="-1" id="businessDetailsCanvas" aria-labelledby="businessDetailsLabel">
            <div class="offcanvas-header">
              <div class="d-flex">
                <div class="flex-grow-1 overflow-hidden pe-5">
                  <div class="mb-1 text-capitalize d-flex">
                    <h5 class="text-truncate font-size-14 mb-0">
                      {{business.businessName}}
                    </h5>
                  </div>
                  <p class="text-truncate mb-0 text-uppercase">Business ID <strong>{{business.businessID}}</strong></p>
                </div>
              </div>
              <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div class="offcanvas-body">
              <div v-bind:class="{ 'alert': true, 'alert-success': color === 'alert-success', 'alert-danger': color === 'alert-danger' }" role="alert">
                <strong>Business Category</strong>
                <p>{{business.businessCategory}}</p>

                <strong>Business Sub Category</strong>
                <p>{{business.businessSubCategory}}</p>

                <strong>Business Activity</strong>
                <p>{{business.businessDes}}</p>

                <strong>Paid SBP Amount</strong>
                <h5>KES {{numberFormat(business.receiptAmount)}}</h5>

                <a class="" href="PrintDocs/Receipts/receipts.html">Receipt No. {{business.billNo}}</a>
              </div>

              <div class="card shadow-none border">
                <div class="card-body p-3">
                  <div class="">
                    <div class="d-flex">
                      <div class="overflow-hidden me-auto">
                        <h5 class="font-size-14 text-truncate mb-1">
                          <a href="javascript: void(0);" class="text-body">Permit Details</a>
                        </h5>
                      </div>
                    </div>

                    <div class="card-body bg-light d-flex mb-4 mt-4">
                      <p class="mb-0">
                        <i class="mdi mdi-file-check-outline text-success align-middle me-3 font-size-24 ml-5 mr-5"></i>
                      </p>
                      <div>
                        <p class="text-muted mb-0">Permit Status</p>
                        <p class="mb-0">
                          <strong class="fw-semibold">
                            <span class="">{{business.status || 'Active'}}</span>
                          </strong>
                        </p>
                      </div>
                    </div>

                    <div class="card-body bg-light d-flex mb-4 mt-4">
                      <p class="mb-0">
                        <i class="mdi mdi-calendar-month text-warning align-middle me-3 font-size-24 ml-5 mr-5"></i>
                      </p>
                      <div>
                        <p class="text-muted mb-0">Duration Paid For</p>
                        <p class="mb-0">
                          <strong class="fw-semibold">
                            <span class="">{{formatDate(business.startDate)}} - {{formatDate(business.endDate)}}</span>
                          </strong>
                        </p>
                      </div>
                    </div>

                    <div class="d-flex">
                      <div class="overflow-hidden w-100">
                        <a @click="printTradePermit(business.businessID)" type="button"
                           class="btn btn-primary waves-effect waves-light w-100 text-center btn-100 btn-flex">
                          <i class="mdi mdi-download font-size-16 align-middle me-2"></i> Download Permit
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card shadow-none border">
                <div class="card-body p-3">
                  <div class="">
                    <div class="d-flex">
                      <div class="overflow-hidden me-auto">
                        <h5 class="font-size-14 text-truncate mb-1">
                          <a href="javascript: void(0);" class="text-body">Business Location Details</a>
                        </h5>
                        <p class="text-muted text-truncate mb-0">{{business.physicalAddress}}</p>
                      </div>
                    </div>

                    <div class="card-body bg-light d-flex mb-4 mt-4">
                      <p class="mb-0">
                        <i class="mdi mdi-map-marker text-warning align-middle me-3 font-size-24 ml-5 mr-5"></i>
                      </p>
                      <div>
                        <p class="text-muted mb-0">Actual Location</p>
                        <p class="mb-0">
                          <strong class="fw-semibold">
                            <span class="the-clicked-address">{{business.physicalAddress}}</span>
                          </strong>
                        </p>
                      </div>
                    </div>

                    <div class="card-body bg-light d-flex mb-4 mt-4">
                      <p class="mb-0">
                        <i class="mdi mdi-map-legend text-warning align-middle me-3 font-size-24 ml-5 mr-5"></i>
                      </p>
                      <div>
                        <p class="text-muted mb-0">Sub County & Ward</p>
                        <p class="mb-0">
                          <strong class="fw-semibold">
                            <span class="">{{business.subCountyName}}, {{business.wardName}}</span>
                          </strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <footer class="footer">
            <div class="container-fluid">
              <div class="row">
                <div class="col-sm-6">© County</div>
                <div class="col-sm-6">
                  <div class="text-sm-end d-sm-block">
                    LeadCab
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>

      <!-- Right bar overlay-->
      <div class="rightbar-overlay"></div>

    </div>
  </div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import ToolBar from "@/components/sbp/ToolBar";
import {trade, execute, biller} from "@/api";
import moment from "moment";

export default {
  name: "SBPFilterMap",
  components: {ToolBar, NavigationBar},
  data() {
    return {
      // Filter states
      selectedSubCounty: '',
      selectedWard: '',
      selectedZone: '',
      autoApplyFilters: false,
      // Default zoom to random business to true
      zoomToMiddle: true,

      // Dropdown data
      subCounties: [],
      wards: [],
      zones: [],

      // Map data
      map: null,
      markers: {
        compliant: [],
        nonCompliant: []
      },

      // Business data
      filteredBusinesses: [],
      compliant: [],
      nonCompliant: [],

      // Statistics
      totalBusinesses: 0,
      compliantCount: 0,
      nonCompliantCount: 0,
      complianceRate: 0,

      // UI states
      loading: false,
      loadingMessage: "Loading data...",
      mapInitialized: false,

      // Selected business details
      business: {
        id: null,
        businessID: null,
        businessName: null,
        subCountyName: null,
        wardName: null,
        physicalAddress: null,
        businessCategory: null,
        businessSubCategory: null,
        buildingName: null,
        businessDes: null,
        status: null,
        receiptAmount: null,
        startDate: null,
        endDate: null,
        billNo: null,
        dateOfIssue: null,
        issuingOfficer: null,
        lastRenewed: null,
        floorNo: null,
        roomNo: null,
        lat: null,
        lng: null,
        permitsCount: null
      },
      color: 'alert-success',

      // County info
      county: {
        lat: null,
        lng: null
      }
    }
  },

  mounted() {
    this.initMap();
    this.loadSubCounties();
    this.menuAccess();
  },

  watch: {
    selectedZone(newVal) {
      // Auto-apply filters if enabled and we have a valid selection
      if (this.autoApplyFilters && (this.selectedSubCounty || this.selectedWard)) {
        this.applyFilters();
      }
    }
  },

  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "SBP Filter Map");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then((res) => {
            // Access logic here
          })
          .catch((e) => {
            // Error handling
          });
    },

    loadSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounties");

      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.subCounties = res.data.data.subCounties || [];
            }
          })
          .catch((e) => {
            console.error("Error loading subcounties:", e);
          });
    },

    onSubCountyChange() {
      // Reset dependent filters
      this.selectedWard = '';
      this.selectedZone = '';
      this.wards = [];
      this.zones = [];

      if (this.selectedSubCounty) {
        this.loadWards();
        this.loadZones();

        // Auto-apply filters if enabled
        if (this.autoApplyFilters) {
          this.applyFilters();
        }
      }
    },

    loadWards() {
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", this.selectedSubCounty);

      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.wards = res.data.data.wards || [];
            }
          })
          .catch((e) => {
            console.error("Error loading wards:", e);
          });
    },

    onWardChange() {
      // Reset zone filter
      this.selectedZone = '';
      this.zones = [];

      // Load zones if ward is selected
      if (this.selectedWard || this.selectedSubCounty) {
        this.loadZones();
      }

      // Auto-apply filters if enabled and we have a selection
      if (this.autoApplyFilters && (this.selectedWard || this.selectedSubCounty)) {
        this.applyFilters();
      }
    },

    loadZones() {
      const data = new FormData();
      data.append("function", "getZones");

      if (this.selectedWard) {
        data.append("wardID", this.selectedWard);
      } else if (this.selectedSubCounty) {
        data.append("subCountyID", this.selectedSubCounty);
      }

      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.zones = res.data.data.zones || [];

              // Remove duplicate zones based on zone name and category
              const uniqueZones = [];
              const zoneMap = new Map();

              this.zones.forEach(zone => {
                const key = `${zone.zone}-${zone.zoneCategory}`;
                if (!zoneMap.has(key)) {
                  zoneMap.set(key, true);
                  uniqueZones.push(zone);
                }
              });

              this.zones = uniqueZones;

              // If no zones found, that's okay - it's optional
              if (this.zones.length === 0) {
                console.log("No zones defined for selected area");
              }
            }
          })
          .catch((e) => {
            console.error("Error loading zones:", e);
            // Don't show error to user since zones are optional
            this.zones = [];
          });
    },

    applyFilters() {
      // Validate that at least subcounty or ward is selected
      if (!this.selectedSubCounty && !this.selectedWard) {
        alert("Please select at least a Sub County or Ward to filter businesses.");
        return;
      }

      this.loading = true;
      this.loadingMessage = "Applying filters...";

      // Clear existing markers
      this.clearMarkers();

      // Load filtered data
      this.loadFilteredBusinesses();
    },

    loadFilteredBusinesses() {
      const data = new FormData();
      data.append("function", "getFilteredBusinesses");

      // Only add filters that have values
      if (this.selectedSubCounty) {
        data.append("subCountyID", this.selectedSubCounty);
      }
      if (this.selectedWard) {
        data.append("wardID", this.selectedWard);
      }
      if (this.selectedZone) {
        data.append("zoneID", this.selectedZone);
      }

      console.log("Loading businesses with filters:", {
        subCounty: this.selectedSubCounty,
        ward: this.selectedWard,
        zone: this.selectedZone
      });

      execute(data, trade)
          .then((res) => {
            console.log("Filter response:", res.data);

            if (res.data.success) {
              const businesses = res.data.data.businesses || [];
              this.county = res.data.data.county || this.county;

              // Debug info
              if (res.data.data.debug) {
                console.log("Debug info:", res.data.data.debug);
              }

              // Separate compliant and non-compliant
              this.compliant = [];
              this.nonCompliant = [];

              const today = new Date();

              businesses.forEach(business => {
                if (business.endDate && new Date(business.endDate) >= today) {
                  this.compliant.push(business);
                } else {
                  this.nonCompliant.push(business);
                }
              });

              console.log(`Found ${businesses.length} total businesses: ${this.compliant.length} compliant, ${this.nonCompliant.length} non-compliant`);

              // Update statistics
              this.updateStatistics();

              // Add markers to map
              this.addFilteredMarkers();

              // Center map on filtered area
              if (businesses.length > 0) {
                this.centerMapOnFilteredArea();
              } else {
                alert("No businesses found in the selected area. This could be because:\n- No businesses exist in this area\n- Businesses don't have location coordinates\n- The selected filters are too restrictive");
              }

              this.loading = false;
            } else {
              console.error("Error response:", res.data.message);
              alert(res.data.message || "Error loading businesses");
              this.loading = false;
            }
          })
          .catch((e) => {
            console.error("Error loading filtered businesses:", e);
            alert("Error loading businesses. Please try again.");
            this.loading = false;
          });
    },

    updateStatistics() {
      this.totalBusinesses = this.compliant.length + this.nonCompliant.length;
      this.compliantCount = this.compliant.length;
      this.nonCompliantCount = this.nonCompliant.length;

      if (this.totalBusinesses > 0) {
        this.complianceRate = Math.round((this.compliantCount / this.totalBusinesses) * 100);
      } else {
        this.complianceRate = 0;
      }
    },

    clearFilters() {
      this.selectedSubCounty = '';
      this.selectedWard = '';
      this.selectedZone = '';
      this.wards = [];
      this.zones = [];

      this.clearMarkers();
      this.resetStatistics();

      // Reset map to default view
      if (this.map && this.county.lat && this.county.lng) {
        this.map.setCenter({
          lat: parseFloat(this.county.lat),
          lng: parseFloat(this.county.lng)
        });
        this.map.setZoom(10);
      }
    },

    resetStatistics() {
      this.totalBusinesses = 0;
      this.compliantCount = 0;
      this.nonCompliantCount = 0;
      this.complianceRate = 0;
    },

    clearMarkers() {
      // Clear compliant markers
      if (this.markers.compliant) {
        this.markers.compliant.forEach(marker => {
          marker.setMap(null);
        });
        this.markers.compliant = [];
      }

      // Clear non-compliant markers
      if (this.markers.nonCompliant) {
        this.markers.nonCompliant.forEach(marker => {
          marker.setMap(null);
        });
        this.markers.nonCompliant = [];
      }
    },

    initMap() {
      const defaultLat = -1.286389; // Default Kenya coordinates
      const defaultLng = 36.817223;

      const options = {
        zoom: 10,
        center: { lat: defaultLat, lng: defaultLng },
        mapTypeId: google.maps.MapTypeId.SATELLITE,
        maxZoom: 20,
        minZoom: 5,
        streetViewControl: false,
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: google.maps.ControlPosition.TOP_LEFT
        }
      };

      this.map = new google.maps.Map(document.getElementById('filterMap'), options);
      this.setupMapControls();
    },

    setupMapControls() {
      // Setup search box
      const input = document.getElementById("pac-input-filter");
      const searchBox = new google.maps.places.SearchBox(input);
      this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

      // Bias the SearchBox results towards current map's viewport
      this.map.addListener("bounds_changed", () => {
        searchBox.setBounds(this.map.getBounds());
      });

      // Handle search box place changes
      searchBox.addListener("places_changed", () => {
        const places = searchBox.getPlaces();

        if (places.length == 0) {
          return;
        }

        // For each place, get the location
        const bounds = new google.maps.LatLngBounds();

        places.forEach(place => {
          if (!place.geometry) {
            console.log("Returned place contains no geometry");
            return;
          }

          if (place.geometry.viewport) {
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
        });

        this.map.fitBounds(bounds);
      });

      // Setup map key toggle
      $('.map-key-card').on('click', () => {
        $('.map-card').toggleClass('d-none');
      });

      $('.close-map-key').on('click', () => {
        $('.map-card').addClass('d-none');
      });
    },

    addFilteredMarkers() {
      // Add compliant business markers
      this.compliant.forEach(business => {
        this.addMarker(business, "assets/images/map-assets/biz/compliant-biz-business.png", 'alert-success');
      });

      // Add non-compliant business markers
      this.nonCompliant.forEach(business => {
        this.addMarker(business, "assets/images/map-assets/biz/noncomplant-business.png", 'alert-danger');
      });
    },

    addMarker(business, iconUrl, color) {
      if (!business.lat || !business.lng) return;

      const marker = new google.maps.Marker({
        position: {lat: Number(business.lat), lng: Number(business.lng)},
        map: this.map,
        icon: {
          url: iconUrl,
          scaledSize: new google.maps.Size(19.7, 27.9),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(0, 0)
        },
        animation: google.maps.Animation.DROP
      });

      // Store marker reference
      if (color === 'alert-success') {
        this.markers.compliant.push(marker);
      } else {
        this.markers.nonCompliant.push(marker);
      }

      // Create info window content
      const content = this.createInfoWindowContent(business, color);
      const infowindow = new google.maps.InfoWindow({
        content: content
      });

      // Add hover event
      marker.addListener('mouseover', () => {
        infowindow.open(this.map, marker);
      });

      marker.addListener('mouseout', () => {
        infowindow.close();
      });

      // Add click event
      marker.addListener('click', () => {
        this.business = business;
        this.color = color;
        this.toggleBounce(marker);

        const theCanvas = new bootstrap.Offcanvas(document.getElementById('businessDetailsCanvas'));
        theCanvas.show();
      });
    },

    createInfoWindowContent(business, color) {
      return `<div class="card mb-0">
                    <div class="card-body px-0 mb-3">
                        <div class="d-flex">
                            <div class="flex-grow-1 overflow-hidden pe-5">
                                <h5 class="text-truncate font-size-16 mb-1 text-capitalize">
                                    ${business.businessName}
                                </h5>
                                <p class="text-truncate text-uppercase text-grey mb-4">${business.subCountyName}</p>
                            </div>
                        </div>
                    </div>

                    <div class="alert alert-info">
                        <strong>Business Location</strong>
                        <p class="text-muted mb-0">
                            <i class="mdi mdi-map-marker text-success align-middle me-1 font-18px"></i>
                            <span class="the-clicked-address">${business.physicalAddress}</span>
                        </p>
                    </div>

                    <div class="alert ${color}" role="alert">
                        <strong>Business Category</strong>
                        <p>${business.businessCategory}</p>

                        <strong>Business Sub Category</strong>
                        <p>${business.businessSubCategory}</p>

                        <strong>Renewal Fee Paid</strong>
                        <h5>KES ${this.numberFormat(business.receiptAmount)}</h5>

                        <a class="text-info text-uppercase mt-4 fw-semibold">Receipt No. ${business.billNo}</a>
                    </div>
                </div>`;
    },

    toggleBounce(marker) {
      if (marker.getAnimation() !== null) {
        marker.setAnimation(null);
      } else {
        marker.setAnimation(google.maps.Animation.BOUNCE);
        setTimeout(() => {
          marker.setAnimation(null);
        }, 750);
      }
    },

    centerMapOnFilteredArea() {
      if (this.markers.compliant.length === 0 && this.markers.nonCompliant.length === 0) {
        return;
      }

      // Get all markers
      const allMarkers = [...this.markers.compliant, ...this.markers.nonCompliant];

      // First, fit bounds to show all markers
      const bounds = new google.maps.LatLngBounds();
      allMarkers.forEach(marker => {
        bounds.extend(marker.getPosition());
      });

      this.map.fitBounds(bounds);

      // If zoom to middle is enabled
      if (this.zoomToMiddle) {
        // Then zoom in on a random valid marker after a short delay
        setTimeout(() => {
          // Get valid markers (on land)
          const validMarkers = allMarkers.filter(marker => this.isMarkerOnLand(marker));

          if (validMarkers.length > 0) {
            // Pick a random marker from valid markers
            const randomIndex = Math.floor(Math.random() * validMarkers.length);
            const randomMarker = validMarkers[randomIndex];
            const markerPosition = randomMarker.getPosition();

            console.log(`Zooming to random business ${randomIndex + 1} of ${validMarkers.length} valid businesses`);

            // Pan to the marker first
            this.map.panTo(markerPosition);

            // Then zoom in after a short delay
            setTimeout(() => {
              const targetZoom = 18; // Close zoom to see the business clearly
              this.map.setZoom(targetZoom);

              // Make the marker bounce after zoom completes
              setTimeout(() => {
                randomMarker.setAnimation(google.maps.Animation.BOUNCE);
                setTimeout(() => {
                  randomMarker.setAnimation(null);
                }, 2000);

                // Show info window for the marker
                const business = this.findBusinessForMarker(randomMarker);
                if (business) {
                  const color = business.endDate && new Date(business.endDate) >= new Date() ? 'alert-success' : 'alert-danger';
                  const content = this.createInfoWindowContent(business, color);
                  const infowindow = new google.maps.InfoWindow({
                    content: content
                  });

                  infowindow.open(this.map, randomMarker);

                  // Auto-close after 5 seconds
                  setTimeout(() => {
                    infowindow.close();
                  }, 5000);
                }
              }, 500);
            }, 800);
          } else {
            console.log("No valid markers found on land to zoom to");
            // If no valid markers, just stay at the fitted bounds view
          }
        }, 1500); // Wait 1.5 seconds after fitting bounds
      } else {
        // Just fit to bounds without zooming to specific marker
        const listener = google.maps.event.addListenerOnce(this.map, 'idle', () => {
          if (this.map.getZoom() > 16) {
            this.map.setZoom(16);
          }
        });
      }
    },

    isMarkerOnLand(marker) {
      const business = this.findBusinessForMarker(marker);
      if (!business) return false;

      const lat = parseFloat(business.lat);
      const lng = parseFloat(business.lng);

      // Basic validation checks
      // 1. Check if coordinates are valid
      if (isNaN(lat) || isNaN(lng)) return false;
      if (lat === 0 && lng === 0) return false; // Null island

      // 2. Kenya approximate bounds check (rough check for obviously wrong coordinates)
      // Kenya is roughly between:
      // Latitude: -5° to 5° (South to North)
      // Longitude: 34° to 42° (West to East)
      if (lat < -5 || lat > 5 || lng < 34 || lng > 42) {
        return false;
      }

      // 3. Simple water body check - only exclude obvious water coordinates
      // Lake Victoria (very rough approximation of center)
      if (lat >= -0.5 && lat <= 0 && lng >= 34.5 && lng <= 35) {
        return false;
      }

      // If basic checks pass, assume it's valid
      return true;
    },

    findBusinessForMarker(marker) {
      // Helper method to find which business corresponds to a marker
      const position = marker.getPosition();
      const lat = position.lat();
      const lng = position.lng();

      // Search in both compliant and non-compliant arrays
      const allBusinesses = [...this.compliant, ...this.nonCompliant];

      return allBusinesses.find(business => {
        return Math.abs(parseFloat(business.lat) - lat) < 0.000001 &&
            Math.abs(parseFloat(business.lng) - lng) < 0.000001;
      });
    },

    zoomIn() {
      const currentZoom = this.map.getZoom();
      const maxZoom = this.map.maxZoom || 20;
      if (currentZoom < maxZoom) {
        this.map.setZoom(currentZoom + 1);
      }
    },

    zoomOut() {
      const currentZoom = this.map.getZoom();
      const minZoom = this.map.minZoom || 1;
      if (currentZoom > minZoom) {
        this.map.setZoom(currentZoom - 1);
      }
    },

    resetZoom() {
      // Reset to show all markers
      if (this.markers.compliant.length > 0 || this.markers.nonCompliant.length > 0) {
        this.centerMapOnFilteredArea();
      } else {
        // Reset to default county view
        if (this.county.lat && this.county.lng) {
          this.map.setCenter({
            lat: parseFloat(this.county.lat),
            lng: parseFloat(this.county.lng)
          });
          this.map.setZoom(10);
        }
      }
    },

    formatDate(date) {
      if (!date) return '';

      let d = new Date(date);
      let day = d.getDate();
      let month = d.toLocaleString('en-US', { month: 'short' });
      let year = d.getFullYear();

      let suffix = '';
      if (day % 10 === 1 && day !== 11) {
        suffix = 'st';
      } else if (day % 10 === 2 && day !== 12) {
        suffix = 'nd';
      } else if (day % 10 === 3 && day !== 13) {
        suffix = 'rd';
      } else {
        suffix = 'th';
      }
      return `${day}${suffix} ${month} ${year}`;
    },

    numberFormat(num) {
      if (!num) return '0';
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num);
    },

    printTradePermit(businessID) {
      const data = new FormData();
      data.append("function", "printTradePermit");
      data.append("businessID", businessID);
      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              localStorage['params'] = JSON.stringify({
                businessID: businessID
              });
              const routeData = this.$router.resolve({name: 'trade'});
              window.open(routeData.href, '_blank');
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    }
  },

  beforeDestroy() {
    // Cleanup
    this.clearMarkers();

    // Remove event listeners
    $('.map-key-card').off('click');
    $('.close-map-key').off('click');
  }
}
</script>

<style scoped>
.main-map-container {
  min-height: 600px;
}

.mini-stats-wid .card-body {
  padding: 1.25rem;
}

.mini-stat-icon {
  width: 60px;
  height: 60px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.map-searcher {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 400px;
  z-index: 5;
}

.map-key-card {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 5;
  cursor: pointer;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.map-card {
  position: absolute;
  top: 70px;
  right: 10px;
  z-index: 5;
  width: 300px;
}

.listview__item {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
}

.listview__img {
  width: 30px;
  height: 30px;
  margin-right: 1rem;
}
</style>